import { useEffect } from "react";

// SOUND //
import useSound from "../../hooks/useSound";
import babyRaspberry from "../../assets/sfx/baby_01_raspberry.mp3";
import babyGiggle from "../../assets/sfx/baby_02_giggle.mp3";
import babyLaugh from "../../assets/sfx/baby_03_laugh.mp3";
import babyHappy from "../../assets/sfx/baby_04_happy.mp3";

// COMPONENTS //
import EditZombie from "../../components/EditZombie";
import WakeButton from "../../components/WakeButton";
import LayeredPixiImage from "../../components/LayeredPixiImage";
import Borders from "../../components/Borders";

// STYLES //
import "./styles.css";

// IMAGES //
import borderPage from "../../assets/border_page.png";
import background from "../../assets/new_baby_bg.png";
import drawing from "../../assets/new_baby_drawing.png";
import clothing from "../../assets/new_baby_clothing.png";
import complexion from "../../assets/new_baby_complexion.png";
import eyes from "../../assets/new_baby_eyes.png";
import hair from "../../assets/new_baby_hair.png";

const newBabyLayers = {
    background: background,
    clothing: clothing,
    complexion: complexion,
    eyes: eyes,
    hair: hair,
    drawing: drawing
};

export default function ShowZombie({ zombie, setZombie, stopMusic }) {

    const { playRandom, stopSound } = useSound();

    useEffect(() => {
        playRandom(
            [
                babyRaspberry,
                babyGiggle,
                babyLaugh,
                babyHappy
            ],
            1
        );

        return stopSound;
    }, []);

    return (
        <div className="game-page show-zombie-page">
            <Borders image={borderPage} scale={0.98} />

            <h1 className="game-title">CONGRATULAZIONI!</h1>

            <div className="game-main-grid show-zombie-main">
                <section className="game-copy">
                    <p>Well, would you look at that. Baby {zombie.name} is cute as a button. Funny thing, parenthood. Every day brings a new chance to teach, protect, and love someone who means more to you than just about anything. Cherish these days while you can. Children have a habit of growing up when you're not looking, and the years slip by faster than a cart rolling downhill.</p>

                    <div className="show-zombie-form-wrapper">
                        <EditZombie zombie={zombie} setZombie={setZombie} stopSound={stopSound} />

                        <WakeButton
                            zombie={zombie}
                            setZombie={setZombie}
                            stopMusic={stopMusic}
                            stopSound={stopSound}
                        />
                    </div>
                </section>

                <div className="game-image-wrapper show-zombie-image-wrapper">
                    <LayeredPixiImage
                        layers={newBabyLayers}
                        zombie={zombie}
                        // width={720}
                        // height={540}
                    />
                </div>
            </div>
        </div>
    );
}
